import { registerCustomElementRegistry } from "@/src/shared_modules/custom_elements/utils/registerCustomElementRegistry";
import { DS_CUSTOM_ELEMENTS_REGISTRY } from "@/src/design_system/shared/constants/customElements";

export const registerDSCustomElements = (): void => {
  registerCustomElementRegistry(DS_CUSTOM_ELEMENTS_REGISTRY);
};
